// prop-types is library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Grid from '@mui/material/Grid';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKAvatar from 'components/MKAvatar';
import MKTypography from 'components/MKTypography';

function ComplexReviewCard({ image, video, color = 'dark', title, review, author }) {
  return (
    <Grid container spacing={3} alignItems="center">
      {/* Media (Video/Image) */}
      <Grid item xs={12} md={6}>
        <MKBox p={{ xs: 0, md: 4 }} height="100%">
          {image ? (
            <MKBox
              component="img"
              src={image}
              alt={title}
              width="100%"
              borderRadius="md"
              shadow="md"
              sx={{ objectFit: 'cover', height: '100%' }}
            />
          ) : video ? (
            <MKBox
              component="video"
              src={video}
              autoPlay
              loop
              muted
              playsInline
              width="100%"
              borderRadius="md"
              shadow="md"
              sx={{ objectFit: 'cover', height: '100%' }}
            />
          ) : null}
        </MKBox>
      </Grid>

      {/* Description */}
      <Grid item xs={12} md={5} display="flex" alignItems="center">
        <MKBox>
          {/* Author info */}
          <MKBox display="flex" alignItems="center" mb={2}>
            <MKAvatar
              src={author.logo}
              alt="Logo"
              size="md"
              shadow="md"
              bgColor={color}
              sx={{ p: 0.5 }}
            />
            <MKBox pl={1.5}>
              <MKTypography variant="button" color={color} fontWeight="bold">
                {author.name}
              </MKTypography>
              {/* <MKTypography variant="caption" color="text">
                {author.role}
              </MKTypography> */}
            </MKBox>
          </MKBox>

          {/* Title and review */}
          <MKTypography variant="h4" color={color} mb={1}>
            {title}
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={2}>
            {review}
          </MKTypography>
        </MKBox>
      </Grid>
    </Grid>
  );
}

// Typechecking props
ComplexReviewCard.propTypes = {
  image: PropTypes.string,
  video: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'info',
    'success',
    'error',
    'warning',
    'dark',
    'light',
  ]),
  title: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired,
  author: PropTypes.shape({
    logo: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    // role: PropTypes.string.isRequired,
  }).isRequired,
};

export default ComplexReviewCard;
